import { getMaximalMonthlyPrice } from './getMaximalMonthlyPrice';
import { getPriceDisplayProps } from './getPriceDisplayProps';
import { findCyclePricing } from './findCyclePricing';
export const cyclePriceDisplayPropsFromProductPricing = _ref => {
  let {
    interval,
    salePricing,
    catalogPricing,
    currencySettings,
    maximalMonthlyPrice: maximalMonthlyPriceFromInput,
    quantity
  } = _ref;
  // TODO - in case of sale and only one cycle in salePricing we have a bug here where maximalMonthlyPrice is from salePricing but cyclePricing is from catalogPricing yearly cycle
  const maximalMonthlyPrice = maximalMonthlyPriceFromInput ?? getMaximalMonthlyPrice({
    catalogPricing,
    salePricing
  });
  const cyclePricing = findCyclePricing(interval, salePricing) ?? findCyclePricing(interval, catalogPricing);
  if (!cyclePricing || !cyclePricing.monthsPerCycle) {
    throw new Error(`No cycle pricing found for interval: ${interval}`);
  }
  return getPriceDisplayProps({
    currencySettings,
    maximalMonthlyPrice,
    monthlyPrice: Number(cyclePricing.monthlyPrice),
    monthsPerCycle: cyclePricing == null ? void 0 : cyclePricing.monthsPerCycle,
    quantity
  });
};
//# sourceMappingURL=cyclePriceDisplayPropsFromProductPricing.js.map